import {
  COMMUNICATION_REQUEST,
  COMMUNICATION_SUCCESS,
  COMMUNICATION_FAIL,
  COMMUNICATION_CLEAR_ERRORS
} from "../Constants/communicarion_const";

export const communication_reducer = (
  state = {
    communication: [],
  },
  action
) => {
  switch (action.type) {
    case COMMUNICATION_REQUEST:
      return {
        loading: true,
        communication: [],
      };
    case COMMUNICATION_SUCCESS:
      return {
        loading: false,
        communication: action.payload.data,
      };
    case COMMUNICATION_FAIL:
      return {
        loading: false,
        communication: null,
        communication_error: action.payload,
      };

    case COMMUNICATION_CLEAR_ERRORS:
      return {
        ...state,
        communication_error: null,
      };
    default:
      return state;
  }
};
